var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4471 12C15.7609 12 18.4471 9.31371 18.4471 6C18.4471 2.68629 15.7609 0 12.4471 0C9.13343 0 6.44714 2.68629 6.44714 6C6.44714 9.31371 9.13343 12 12.4471 12Z",
    fill: "#1DB469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4471 13.999C7.47886 14.0046 3.45267 18.0307 3.44714 22.999C3.44714 23.5513 3.89485 23.999 4.44713 23.999H20.4471C20.9994 23.999 21.4471 23.5513 21.4471 22.999C21.4416 18.0307 17.4154 14.0045 12.4471 13.999Z",
    fill: "#1DB469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProfile);
export default __webpack_public_path__ + "static/media/activeProfile.b19845ae88e72002f9ab042239900525.svg";
export { ForwardRef as ReactComponent };